import ajax from '../../helpers/ajax'
import { objectKeysToSnakeCase } from '../../helpers/transform-object-keys'
import { OneClickFromCrmStatus } from './one-click-from-crm-statuses'

export default {
  fetchGlobalSubscriptionDataFromCrm({ state, commit }) {
    ajax.get({
      url: state.globalSubscriptionCheck.url,
      throwOnFailure: true,
      successHandler: (resp) => {
        if (resp.subscribed) {
          commit('setCrmSubscribed')
        }
      }
    }).catch(() => {
      // If the network call to get the data fails, we want to just handle that situation,
      // rather than showing a "network call failed" message to the user.
      commit('setGlobalSubscriptionCheckFromCrmFailed')
    })
  },

  fetchOneClickDataFromCrm({ state, commit, dispatch }) {
    ajax.get({
      url: state.crmOneClickUrl,
      camelCaseResponse: false,
      throwOnFailure: true,
      successHandler: (resp) => {
        // We got data from the CRM!
        dispatch('handleIfAlreadyTakenAction', resp).then((alreadyTakenAction) => {
          if (!alreadyTakenAction) {
            // Use the one-click signing UX! We got enough information and the action-taker hasn't already taken action on this campaign.
            commit('activateOneClickFromCrm', resp)
            commit('applyOneClickFieldMappings', resp)

            dispatch('trackSawOneClick')

            state.oneClickFromCrmStatus = OneClickFromCrmStatus.SUCCEEDED

            if (resp.subscribed) {
              commit('setCrmSubscribed')
            }
          } else {
            state.oneClickFromCrmStatus = OneClickFromCrmStatus.ALREADY_TOOK_ACTION
          }
        })
      }
    }).catch(() => {
      // If the network call to get the data fails, we want to just handle that situation,
      // rather than showing a "network call failed" message to the user.
      commit('cancelOneClick')

      // Must be set after calling cancelOneClick to avoid setting OneClickFromCrmStatus.CANCELLED instead
      state.oneClickFromCrmStatus = OneClickFromCrmStatus.FAILED

      if (state.globalSubscriptionCheck.enabled) {
        commit('setGlobalSubscriptionCheckFromCrmFailed')
      }
    })
  }
}

export function getNewActionPayload(state, actionType, suppressEmailOptInField, {friendlyCaptchaSolution, hcaptchaResponse, recaptchaToken, turnstileToken }) {
  const data = {
    [actionType]: {
      ...objectKeysToSnakeCase(state.action),
      ...state.extraParams
    },
    retry_count: state.retryCount
  }

  // Reset the additional fields attribute that we want to send without transforming to snake case
  data[actionType].additional_fields = state.action.additionalFields

  if (suppressEmailOptInField) {
    delete data[actionType].join_organisation
    delete data[actionType].email_opt_in_type_id
  }

  if (friendlyCaptchaSolution) {
    data.friendly_captcha_solution = friendlyCaptchaSolution
  }

  if (hcaptchaResponse) {
    data.hcaptcha_response = hcaptchaResponse
  }

  if (recaptchaToken) {
    data.recaptcha_token = recaptchaToken
  }

  if (turnstileToken) {
    data.turnstile_token = turnstileToken
  }

  return data
}
